import React from "react";

const ShowPlanes = ({ type, data, Image, title, handelSelectedRecharge, selectedRecharge }) => {
console.log({ type, data, Image, title, handelSelectedRecharge, selectedRecharge });
  return (
    <>
      {type === "bundle" && (
        <div className="bundel-main-div">
          {data?.map(
            (item, i) =>
              !(typeof item?.prices?.retail?.amount === "object") && (
                <div
                  key={i}
                  onClick={() => handelSelectedRecharge(item, "airtime")}
                  className={selectedRecharge?.recharge?.id === item.id ? "recharge-active" : ""}
                >
                  <div className="imgae-price-recharge">
                    {" "}
                    <img src={Image} alt={title} />
                    <span>
                      {" "}
                      <img src={"/aed-w.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " />{" "}
                      {item?.prices?.retail?.amount}
                    </span>
                  </div>

                  <p>{item.description}</p>
                </div>
              )
          )}
        </div>
      )}
      {type === "data" && (
        <div className="bundel-main-div">
          {data?.map(
            (item, i) =>
              !(typeof item?.prices?.retail?.amount === "object") && (
                <div
                  key={i}
                  onClick={() => handelSelectedRecharge(item, "airtime")}
                  className={selectedRecharge?.recharge?.id === item.id ? "recharge-active" : ""}
                >
                  <div className="imgae-price-recharge">
                    {" "}
                    <img src={Image} alt={title} />
                    <span>
                      {" "}
                      <img src={"/aed-w.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " />{" "}
                      {item?.prices?.retail?.amount}
                    </span>
                  </div>

                  <p>{item.description}</p>
                </div>
              )
          )}
        </div>
      )}
      {type === "airtime" && (
        <div className="bundel-main-div">
          {data?.map(
            (item, i) =>
              !(typeof item?.prices?.retail?.amount === "object") && (
                <div
                  key={i}
                  onClick={() => handelSelectedRecharge(item, "airtime")}
                  className={selectedRecharge?.recharge?.id === item.id ? "recharge-active" : ""}
                >
                  <div className="imgae-price-recharge">
                    {" "}
                    <img src={Image} alt={title} />
                    <span>
                      {" "}
                      <img src={"/aed-w.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " />{" "}
                      {item?.prices?.retail?.amount}
                    </span>
                  </div>

                  <p>{item.description}</p>
                </div>
              )
          )}
        </div>
      )}
    </>
  );
};

export default ShowPlanes;
